var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cassie-form-builder',{staticClass:"cassie-builder",attrs:{"mode":"theme","read-only":!_vm.userFullPermissions,"channels":_vm.mappedChannels}})}
var staticRenderFns = []

export { render, staticRenderFns }